export const universityRoutes = {
  default: 'university',
}
